export default "__VITE_PUBLIC_ASSET__88ae8892__"